const MAX_REPORT_KEY_LENGTH = 200;

/**
 * True the first time `seen` meets `text`, so a failure that repeats on every
 * retry reaches Sentry once per page. Long numbers are masked: an error that
 * carries a timestamp or an id would otherwise count as new on every retry,
 * while an HTTP status is what tells two failures apart.
 */
export function isFirstReport(seen: Set<string>, text: string): boolean {
  const key = text.replace(/\d{4,}/g, "#").slice(0, MAX_REPORT_KEY_LENGTH);
  if (seen.has(key)) {
    return false;
  }
  seen.add(key);
  return true;
}
